module.exports = __webpack_public_path__ + "img/fashion_90.0d16664b.jpg";